import { useFormik } from "formik";
import { useEffect, useState } from "react";
import * as yup from "yup";
import axiosInstance from "../../../services/axiosComman";
import { CloseIcon } from "../../../assets/icons";
import { NuInput, NuTextArea, NuUpload } from "../../../utils/Inputs";
import FormikSelectTwo from "../../../utils/Select";
import { CountryMIN } from "../../../assets/data/CountryMini";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import { toast } from "react-toastify";

export default function CreateorUpdate({
  data={},
  visible,
  onClose,
  refreshData,
  id,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [show, setShow] = useState(false);
  const [createNew, setCreateNew] = useState({
    companyName: "",
    address: "",
    mobile: "",
    email: "",
    companyWebsite: "",
    attachment: "",
    country: "",
    city: "",
  });

  useEffect(() => {
    if(data){
      setCreateNew({
        companyName: data?.companyName||"",
        address: data?.address||"",
        email: data?.email||"",
        mobile: data?.mobile||"",
        companyWebsite: data?.companyWebsite||"",
        country: data?.country||"",
        city: data?.city||"",
      });
    }
  }, [data]);
  function handleImageChange(e) {
    const { files, value } = e.target;
    setSelectedFile(files);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      companyName: yup
        .string()
        .min(3, "Name must be at least 3 characters")
        .max(45, "Name cannot exceed 45 characters")
        .required("Name is requred"),
      email: yup
        .string()
        .email("Email is invalid")
        .required("Email is requred"),
      mobile: yup
        .string()
        .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
        .required("mobile is requerd"),
    }),
    onSubmit: (value,{resetForm}) => {
      setIsLoading(true);
      if (data?.companyId) {
        let reqObjs = new FormData();
        reqObjs.append("company_info", JSON.stringify(value));
        reqObjs.append(
          "company_logo",
          selectedFile !== null ? selectedFile[0] : [{ FileStorage: "" }]
        );

        axiosInstance
          .put(`/company-info/${data?.companyId}`, reqObjs)
          .then((res) => {
            if (res.data) {
              setIsLoading(false);
              onClose();
              refreshData();
              resetForm()
              toast.success(<p className="test-sm">{`${res.data.msg||res.data.message}`||"Data Updated Successfully"}</p>,)
            } else {
              setIsLoading(false);
              toast.error(<p className="test-sm">{`${res.data.msg||res.data.message}`||"Data Updated Unsuccessfully"}</p>,)
            }
          })
          .catch((err) => {
            setIsLoading(false);
            toast.error(<p className="test-sm">{`${err?.response?.data.msg || err?.response?.data.message || err?.response?.data.error}`||"Data Updated Unsuccessfully"}</p>,)
          });
      } else {
        let reqObjs = new FormData();
        reqObjs.append("company_info", JSON.stringify(value));
        reqObjs.append(
          "company_logo",
          selectedFile !== null ? selectedFile[0] : selectedFile
        );
        axiosInstance
          .post("/company-info/", reqObjs)
          .then((res) => {
            if (res.data) {
              setIsLoading(false);
              refreshData();
              onClose();
              resetForm()
              toast.success(<p className="test-sm">{`${res.data.msg||res.data.message}`||"Data Added Successfully"}</p>,)
              // Toast.fire({
              //   icon: "success",
              //   title: res.data.message || "UserInfo is Created",
              // });
            } else {
              setIsLoading(false);
              toast.error(<p className="test-sm">{`${res.data.msg||res.data.message}`||"Data Updated Unsuccessfully"}</p>,)

              // Toast.fire({
              //   icon: "error",
              //   title: res.data.message || "UserInfo is not Created",
              // });
            }
          })
          .catch((err) => {
            setIsLoading(false);
            toast.error(<p className="test-sm">{`${err?.response?.data.msg || err?.response?.data.message || err?.response?.data.error||"Data Updated Unsuccessfully"}`}</p>,)

            // Toast.fire({
            //   icon: "error",
            //   title: err?.response?.data.msg || err?.response?.data.message || err?.response?.data.error || "User Managment Update Unsuccessfully",
            // });
          });
      }
    },
  });

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
      e.preventDefault(); // Prevent form submission on Enter
    }
  };

  const handleOnClose = () => {
    onClose();
    formik.resetForm();
  };

  if (!visible) return null;
  return (
    <>
      <div
        id="modal"
        // onClick={handleOnClose}
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white  max-h-[calc(100vh-70px)] overflow-hidden p-2 rounded-xl w-6/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>

            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={handleOnClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className=" w-full h-[calc(100vh-120px)] overflow-y-auto relative px-6 flex flex-wrap justify-between">
              <NuInput
                formik={formik}
                name="companyName"
                label="Company Name"
                width="w-full"
                placeholder="Company Name"
              />
              <NuTextArea
                formik={formik}
                name="address"
                label="Address"
                width="w-full"
                placeholder="Address"
              />
              <FormikSelectTwo
                formik={formik}
                name="country"
                label="Country"
                width="w-1/2"
                placeholder="Country"
                Options={CountryMIN}
               />
              <NuInput
                formik={formik}
                name="city"
                label="City"
                width="w-1/2"
                placeholder="City"
              />
              <NuInput
                formik={formik}
                name="companyWebsite"
                label="Website"
                width="w-1/2"
                placeholder="Website"
              />
              <NuInput
                formik={formik}
                name="mobile"
                label="Phone No."
                width="w-1/2"
                placeholder="Phone No."
                type="number"
              />
              <NuInput
                formik={formik}
                name="email"
                label="Email"
                width="w-1/2"
                placeholder="email"
                type="email"
              />
              <NuUpload
                  label="Logo"
                  width="w-1/2"
                  onChange={handleImageChange}
                  accept="image/*"
                 />
              <div className="flex w-full items-center justify-end px-6 py-6 rounded-b text-xs 2xl:text-sm">
                <CancelButton onClose={handleOnClose} isLoading={isLoading} />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
